<template>
  <v-data-table
    :loading="isEmpty(items.schema)"
    loading-text="Loading..."
    :headers="headers"
    :items="items.data"
    :items-per-page="-1"
    class="text-truncate"
    dense
    disable-filtering
    disable-sort
    hide-default-footer
  >
    <template v-slot:[`item.index`]="{ item }">
      <stats :column="item.column" :key="item.column" />
      {{ item.index }}
    </template>
  </v-data-table>
</template>

<script>
import Stats from '@/components/stats'
export default {
  props: {
    items: { type: Object, required: true }
  },
  components: {
    Stats
  },
  data () {
    return {
      headers: []
    }
  },
  watch: {
    items: {
      deep: true,
      handler() {
        if ('fields' in this.items.schema) {
          this.setHeaders(this.items.schema.fields)
        }
      }
    }
  },
  mounted() {
    if ('fields' in this.items.schema) {
      this.setHeaders(this.items.schema.fields)
    }
  },
  methods: {
    setHeaders(fields) {
      fields.forEach((val, key, arr) => {
        if (Object.is(arr.length - 1, key)) {
          this.headers.push({ text: val.name.toUpperCase(), value: val.name, width: "99%" })
        } else {
          this.headers.push({ text: val.name.toUpperCase(), value: val.name, width: "1%" })
        }
      })
      this.headers.unshift({
        text: "",
        value: "index",
        width: "1%"
      })
    }
  }
}
</script>
